import { Image } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import WastageAddEditComponent from "../../../component/inventory/wastage/WastageAddEditComponent";

export default function WastageEdit() {
  const navigate = useNavigate();

  function onHandleCancel() {
    navigate("/inventory/ingredients");
  }

  function onHandleSave() {
    console.log("___ingredientsWithoutId___");
  }

  return (
    <div className="flex flex-col">
      {/* <CustomLoader /> */}
      <Header
        title={`McDonalds Food Chains`}
        menu={constants.MENU.INVENTORY}
        currentMenuKey={"T_7_S_7_L_7"}
      />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.MENU.INVENTORY}
        />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent
              title={"Edit Wastage"}
              listRoute="/inventory/wastage"
            />
          </div>

          <div className="flex justify-center w-[688px] bg-white">
            <WastageAddEditComponent editMode={true} />
          </div>
        </div>
      </div>
    </div>
  );
}
